export default __webpack_public_path__ + "static/media/info-circle-fill.55475f7b.svg";